/* Copyright (c) 2017 Backpack Health LLC */

import { types as colorThemActionTypes } from 'redux/actions/lists';

const initialState = {
  isFetching: false,
  collection: [],
  defaultColorTheme: {
    base_color: { r: 216, g: 27, b: 81, a: 1 },
    highlight_color: { r: 255, g: 92, b: 125, a: 1 },
    accent_color: { r: 160, g: 0, b: 41, a: 1 },
  },
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case colorThemActionTypes.COLOR_THEME_REQUEST:
      return _.assign({}, state, {
        isFetching: true,
      });
    case colorThemActionTypes.COLOR_THEME_RECEIVE:
      return _.assign({}, {
        isFetching: false,
        defaultColorTheme: action.payload.collection[0],
      }, action.payload);
    default:
      return state;
  }
}

const selectors = {
  getDefaultColorTheme: (state) => state.lists.colorTheme.defaultColorTheme,
  get: (state, id) => state.lists.colorTheme.collection.find(c => c.id === id),
};

export default selectors;
